import { NavLink } from "react-router-dom";
import {
  IoBriefcaseOutline,
  IoChatbubbleEllipsesOutline,
  IoCloudOutline,
  IoDocumentTextOutline,
  IoGridOutline,
  IoLayersOutline,
  IoMailOpenOutline,
  IoNewspaperOutline,
  IoPeopleOutline,
  IoReceiptOutline,
} from "react-icons/io5";
import logo from "../../assets/images/logo.svg";
import NavGroup from "./NavGroup";

const linkClass = ({ isActive }) =>
  `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition ${
    isActive
      ? "bg-emerald-500/15 text-emerald-300 ring-1 ring-emerald-500/30"
      : "text-slate-400 hover:bg-slate-800/80 hover:text-white"
  }`;

export default function Sidebar({ onNavigate }) {
  return (
    <aside className="flex h-full w-64 flex-col border-r border-slate-800 bg-[#030f0f]">
      <div className="border-b border-slate-800 px-5 py-6">
        <img src={logo} alt="Vuca.li" className="h-10 w-auto brightness-0 invert" />
        <p className="mt-2 text-sm font-medium text-slate-400">CMS Dashboard</p>
      </div>

      <nav className="flex-1 overflow-y-auto p-3" aria-label="Dashboard">
        <NavGroup title="Services">
          <NavLink
            to="/cmsadmin/dashboard/services"
            className={linkClass}
            onClick={onNavigate}
          >
            <IoGridOutline className="h-5 w-5 shrink-0" />
            Service pages
          </NavLink>
        </NavGroup>

        <NavGroup title="Industries">
          <NavLink
            to="/cmsadmin/dashboard/industries"
            className={linkClass}
            onClick={onNavigate}
          >
            <IoLayersOutline className="h-5 w-5 shrink-0" />
            Industry pages
          </NavLink>
        </NavGroup>

        <NavGroup title="Website content">
          <NavLink
            to="/cmsadmin/dashboard/pages"
            className={linkClass}
            onClick={onNavigate}
          >
            <IoDocumentTextOutline className="h-5 w-5 shrink-0" />
            All pages
          </NavLink>
          <NavLink
            to="/cmsadmin/dashboard/articles"
            className={linkClass}
            onClick={onNavigate}
          >
            <IoNewspaperOutline className="h-5 w-5 shrink-0" />
            Articles
          </NavLink>
          <NavLink
            to="/cmsadmin/dashboard/projects"
            className={linkClass}
            onClick={onNavigate}
          >
            <IoBriefcaseOutline className="h-5 w-5 shrink-0" />
            Work projects
          </NavLink>
        </NavGroup>

        <NavGroup title="Careers">
          <NavLink
            to="/cmsadmin/dashboard/positions"
            className={linkClass}
            onClick={onNavigate}
          >
            <IoPeopleOutline className="h-5 w-5 shrink-0" />
            Open positions
          </NavLink>
          <NavLink
            to="/cmsadmin/dashboard/applications"
            className={linkClass}
            onClick={onNavigate}
          >
            <IoMailOpenOutline className="h-5 w-5 shrink-0" />
            Job applications
          </NavLink>
        </NavGroup>

        <NavGroup title="Form submissions">
          <NavLink
            to="/cmsadmin/dashboard/contact-messages"
            className={linkClass}
            onClick={onNavigate}
          >
            <IoChatbubbleEllipsesOutline className="h-5 w-5 shrink-0" />
            Contact messages
          </NavLink>
          <NavLink
            to="/cmsadmin/dashboard/quote-requests"
            className={linkClass}
            onClick={onNavigate}
          >
            <IoReceiptOutline className="h-5 w-5 shrink-0" />
            Quote requests
          </NavLink>
          <NavLink
            to="/cmsadmin/dashboard/hosting-orders"
            className={linkClass}
            onClick={onNavigate}
          >
            <IoCloudOutline className="h-5 w-5 shrink-0" />
            Hosting orders
          </NavLink>
        </NavGroup>
      </nav>
    </aside>
  );
}
